import { css } from '@microsoft/fast-element';
import { genericFormStyling } from '../../../../../styles';

export const LocationTabStyles = css`
  ${genericFormStyling}
  zero-text-area,
  zero-text-field,
  zero-number-field,
  zero-select {
    width: 100%;
  }

  zero-select::part(listbox) {
    max-height: 250px;
  }

  .short-dropdown zero-select::part(listbox) {
    max-height: 220px;
  }
`;
